export enum SupervisorPlaceTypeEnum {
    Done = 0,
    LoadIn = 1,
    LoadOut = 2,
    All = 3,
    Storno = 4,
    CustomClearance = 5
}
